import * as React from 'react';
import styles from './index.less';
import { Input } from 'antd';
import { FI18n } from '@freelog/tools-lib';

interface FAmountRangeInputProps {
  minAmount: string;
  maxAmount: string;
  onChangeMinAmount: (value: string) => void;
  onChangeMaxAmount: (value: string) => void;
}

function FAmountRangeInput({ minAmount, maxAmount, onChangeMinAmount, onChangeMaxAmount }: FAmountRangeInputProps) {

  const [$focused, set$focused] = React.useState(false);

  return (<div
    className={`${styles.amountInput} ${$focused ? styles.focused : ''}`}
  >
    <Input
      value={minAmount}
      onChange={(e) => {
        const value = e.target.value;
        if (value === '') {
          onChangeMinAmount('');
          return;
        }
        // 验证：判断 value 是否是大于等于0的数字，最多2位小数（允许输入过程中的小数点）
        if (!/^(0|[1-9]\d*)(\.\d{0,2})?$/.test(value)) {
          // fMessage('请输入有效的金额，最多2位小数', 'error');
          return;
        }
        // console.log(value, 'value');

        onChangeMinAmount(value);
      }}
      style={{ width: '100%', height: 38, border: 'none' }}
      placeholder={FI18n.i18nNext.tAuto('transactions_filter_amount_min')}
      onBlur={() => {
        set$focused(false);
        // onBlurMinAmount();
        if (
          maxAmount !== '' &&
          minAmount !== '' &&
          Number(minAmount) > Number(maxAmount)
        ) {
          onChangeMinAmount(maxAmount);
        }
      }}
      bordered={false}
      onFocus={() => {
        set$focused(true);
      }}
    />
    <span className={styles.separator}>—</span>
    <Input
      value={maxAmount}
      onChange={(e) => {
        const value = e.target.value;
        if (value === '') {
          onChangeMaxAmount('');
          return;
        }
        // 验证：判断 value 是否是大于等于0的数字，最多2位小数（允许输入过程中的小数点）
        if (!/^(0|[1-9]\d*)(\.\d{0,2})?$/.test(value)) {
          return;
        }

        onChangeMaxAmount(value);
      }}
      style={{ width: '100%', height: 38, border: 'none' }}
      placeholder={FI18n.i18nNext.tAuto('transactions_filter_amount_max')}
      onBlur={() => {
        set$focused(false);
        if (
          minAmount !== '' &&
          maxAmount !== '' &&
          Number(minAmount) > Number(maxAmount)
        ) {
          onChangeMaxAmount(minAmount);
        }
      }}
      bordered={false}
      onFocus={() => {
        set$focused(true);
      }}
    // onMouseEnter={() => {
    //   set$focused(true);
    // }}
    // onMouseLeave={() => {
    //   set$focused(false);
    // }}
    />
  </div>);
}

export default FAmountRangeInput;
